interface Params {
  orderItem: Pick<App.OrderItem, 'package' | 'packagePrice' | 'channelMarkupId'>
  duration: number
  packageUniqueKey?: string
  isLpc: boolean
  price: number
  memberPrice: number
  useMemberPrice: boolean
  surcharge: number
}

/** The new accommodation total for a date change, before subtracting the original total. */
export default function getHotelDateChangePrice({
  orderItem,
  duration,
  packageUniqueKey,
  isLpc,
  price,
  memberPrice,
  useMemberPrice,
  surcharge,
}: Params): number {
  const newPackageSelected = orderItem.package.duration !== duration ||
    (packageUniqueKey !== undefined && orderItem.package.uniqueKey !== packageUniqueKey)

  const priceToUse = newPackageSelected || orderItem.channelMarkupId || isLpc ? price : orderItem.packagePrice
  const memberPriceToUse = newPackageSelected || isLpc ? memberPrice : orderItem.packagePrice
  const nextPrice = useMemberPrice && memberPriceToUse > 0 ? memberPriceToUse : priceToUse

  return nextPrice + surcharge
}
